// extracted by mini-css-extract-plugin
export default {"hpc__row":"RecommendedSlider_hpc__row__cuoOJ","hpc__row__title":"RecommendedSlider_hpc__row__title__b2gCa","hpc__background":"RecommendedSlider_hpc__background__NxyLw"};